import { type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { kFakeOperatorEnabled, kFakeOperatorRole } from '../config'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="flex h-screen flex-col">
      {kFakeOperatorEnabled && (
        <div
          className="bg-red-600 px-4 py-1 text-center text-xs font-bold
                     uppercase tracking-wide text-white"
          role="alert"
        >
          DEV FAKE OPERATOR ({kFakeOperatorRole}) — bypass active
        </div>
      )}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <div className="flex flex-1 flex-col">
          <TopBar />
          <main className="flex-1 overflow-auto bg-stone-50">{children}</main>
        </div>
      </div>
    </div>
  )
}
